module.exports = __webpack_public_path__ + "img/sem_bandeira.0a1cbc18.svg";